import React, { useState } from 'react';
import Avatar from 'components/Avatar';
import BasicSelectionMarker from 'components/BasicSelectionMarker';
import './styles.css';

const AvatarWithSelection = ({
  size,
  name,
  image,
  status,
  selected,
  onSelect,
  renderStatus,
}) => {
  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  return (
    <div className="avatar-with-selection">
      <div
        className="avatar-with-selection__photo"
        onMouseEnter={hoverOn}
        onMouseLeave={hoverOff}
        onMouseOver={hoverOn}
        onMouseOut={hoverOff}
        onMouseUp={hoverOn}
        onMouseDown={hoverOff}
        onFocus={hoverOn}
        onBlur={hoverOff}
        onClick={() => onSelect(selected)}
      >
        <Avatar size={size} name={name} image={image} />
        <div className="avatar-with-selection__marker">
          <BasicSelectionMarker selected={selected} hover={hover} />
        </div>
      </div>

      {renderStatus && (
        <div className="avatar-with-selection__status">
          {renderStatus(status)}
        </div>
      )}
    </div>
  );
};

export default AvatarWithSelection;
